import { atom } from 'jotai';

/**
 * True once the Heidi Remote dev section has forced a device scenario this
 * session, so the DevTools rail + Remote tab can badge it like any other override.
 *
 * Lives under `src/components/dev/` rather than `src/atoms/`: unlike the shared
 * `*DevAtoms` switches, no production code reads it — only the dev section writes
 * it and the sidebar badge reads it.
 *
 * In-memory on purpose (not `atomWithStorage`): the simulator writes the real,
 * in-memory Chronicle atoms, which reset on reload — this marker has to reset
 * with them, or the badge would strand "on" over an already-cleared state.
 *
 * Tracks "a scenario was applied", not "atoms are non-default", so it never
 * false-lights for an engineer whose real remote is genuinely connected on desktop.
 */
export const remoteSimAppliedAtom = atom(false);

remoteSimAppliedAtom.debugLabel = 'remoteSimAppliedAtom';
